import { Logger } from 'vue-infra';
import sendBam from './sendBam';
import { BAM_EVENT_NAME_TYPES, BAM_TRIGGER_SOURCE } from './BamConsts';

const logger = Logger.getLogger('alertBam');

export default {
  sendDisplayAlertBam(options) {
    sendBam(logger, {
      widgetName: options.widgetName,
      eventName: BAM_EVENT_NAME_TYPES.DISPLAY_ALERT,
      userAction: BAM_EVENT_NAME_TYPES.DISPLAY_ALERT,
      userActionContext: options.metricName,
      targetSource: options.source,
      value: JSON.stringify(options.score),
    });
  },
  sendSaveAlertBam(options) {
    sendBam(logger, {
      widgetName: options.widgetName,
      eventName: options.saveType,
      userAction: options.saveType,
      userActionContext: options.metricNames.join(),
      targetSource: BAM_TRIGGER_SOURCE.ALERT_DIALOG,
      value: JSON.stringify(options.alertData),
    });
  },
  sendSaveValidationFailAlertBam(options) {
    sendBam(logger, {
      widgetName: options.widgetName,
      eventName: BAM_EVENT_NAME_TYPES.VALIDATION_FAIL_ALERT,
      userAction: BAM_EVENT_NAME_TYPES.SAVE_ALERT,
      userActionContext: options.invalidMetricNames.join(),
      targetSource: BAM_TRIGGER_SOURCE.ALERT_DIALOG,
      value: JSON.stringify(options.invalidData),
    });
  },
  sendClearMetricAlertFieldsBam(options) {
    sendBam(logger, {
      widgetName: options.widgetName,
      eventName: BAM_EVENT_NAME_TYPES.CLEAR_FIELDS,
      userAction: BAM_EVENT_NAME_TYPES.CLEAR_FIELDS,
      userActionContext: options.metricName,
      targetSource: BAM_TRIGGER_SOURCE.ALERT_DIALOG,
      value: JSON.stringify(options.values),
    });
  },
  sendThresholdReachBam(options) {
    sendBam(logger, {
      widgetName: options.widgetName,
      eventName: BAM_EVENT_NAME_TYPES.THRESHOLD_REACHED,
      userAction: BAM_EVENT_NAME_TYPES.SYSTEM,
      userActionContext: options.metricName,
      targetSource: options.widgetName,
      value: JSON.stringify(options.values),
    });
  },
};
